"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsPreviewContainer = void 0;
var products_preview_container_1 = require("./products-preview.container");
Object.defineProperty(exports, "ProductsPreviewContainer", { enumerable: true, get: function () { return products_preview_container_1.ProductsPreviewContainer; } });
